import { createCrudActions } from '../utils/crudGenerator';
import { axios } from '../connection/ConnectionHandler';

const formatZones = (data) => {
    if (!data) {
        return [];
    }
    const formatItem = (item) => ({
        ...item,
        label: `${item.name}`,
        value: item._id,
    });

    if (Array.isArray(data)) {
        return data.map(formatItem);
    }
    return formatItem(data);
};

export const {
    fetch: fetchZones,
    create: createZone,
    update: updateZone,
    delete: deleteZones
} = createCrudActions('ZONE', "Zona", formatZones);

export const deleteDuplicateZones = () => async () => {
    try {
        const response = await axios.delete('zone/duplicates');
        if (typeof response === "number") {
            return { status: response };
        }

        return { status: response.status, ...response.data };
    } catch (error) {
        return { status: error?.response?.status ?? 0 };
    }
};
